import { Component, OnInit, ViewChild } from '@angular/core';
import { MasterConsultaUsuariosService } from './master-consulta-usuarios.service';

import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { CustomAuthenticationService } from '@app/auth/services/custom-authentication.service';
import { User } from '@app/core/models/user.model';
import { DialogBoxService } from '@app/custom-shared/components/alerts/dialog-box-service';
import { PermissionsType } from '@app/custom-shared/enums/permissions-type.enum';
import { AppScreenBase } from '@app/custom-shared/util/app-screen-base';
import { MasterCreateUserComponent } from '../create-user/master-create-user.component';
import { MasterClienteCreateUserComponent } from '../master-cliente/cliente-criar-usuario-stepper/master-cliente-create-user.component';
import { MasterVisualizarUsuarioComponent } from '../visualizar-usuario/master-visualizar-usuario.component';


@Component({
  selector: 'app-master-consulta-usuarios',
  templateUrl: './master-consulta-usuarios.component.html',

  styleUrls: ['./master-consulta-usuarios.component.scss'],
})
export class MasterConsultaUsuariosComponent extends AppScreenBase
  implements OnInit {
  protected onClose(): void { }

  users: any;
  displayedColumns: string[] = [
    'name',
    'userSso',
    'email',
    'status',
    'actions',
  ];
  sorted: boolean = false;
  filterAutoComplete: Array<any>;
  usersComplete: any;
  permission: PermissionsType = PermissionsType.master;
  criar: boolean = false;
  editar: boolean = false;

  @ViewChild('sortUsers', { static: false }) sortUsers: MatSort;
  clientExist: boolean;
  userFilter: any;
  constructor(
    private customAuthenticationService: CustomAuthenticationService,
    private _masterUsersService: MasterConsultaUsuariosService,
    private dialog: MatDialog,
    private snackBarService: DialogBoxService,
  ) {
    super();

    // this.checkIfExistClientsToAssociate();
  }

  ngOnInit() {
    this.getUsers();

    this.criar = this.customAuthenticationService.hasPermission(
      PermissionsType.cadastrarUsuarios,
    );

    this.editar = this.customAuthenticationService.hasPermission(
      PermissionsType.editarUsuarios,
    );
  }

  setClientExist(exist) {
    this.clientExist = exist;
  }

  // async checkIfExistClientsToAssociate() {
  //   try {
  //     const response = await this._masterUsersService.checkIfExistClientsToAssociate();
  //     let exist = response.length > 0 ? true : false;
  //     this.setClientExist(exist);
  //   } catch (e) {
  //     console.error(e);
  //   }
  // }

  async getUsers() {
    await this._masterUsersService.getUsers().then(response => {
      this.users = new MatTableDataSource<User>(response.naturalSort(['name']));
    });

    this.users.sortingDataAccessor = (data, sortHeaderId) =>
      typeof data[sortHeaderId] === 'string'
        ? data[sortHeaderId].toLowerCase()
        : data[sortHeaderId]

    this.users.sort = this.sortUsers;
    this.sortUsers.disableClear = true;
    if (this.userFilter != null) {
      this.users.filter = this.userFilter;

    }
    // this.users.forEach(element => {

    //   if (element.email == null) {
    //     element.email = ''
    //   }
    //   if (element.name == null) {
    //     element.name = ''
    //   }
    //   if (element.id == null) {
    //     element.id = ''
    //   } if (element.status == null) {
    //     element.status = ''
    //   } if (element.userSso == null) {
    //     element.userSso = ''
    //   }



    // });
  }

  filterUsers(event: Event) {
    this.users.filterPredicate = (data, filter) => {
      if (data.name === null || data.name === undefined) {
        data.name = '';
      }



      return data.name.toLowerCase().includes(filter.toLowerCase());
    };
    this.userFilter = (event.target as HTMLInputElement).value;
    this.users.filter = this.userFilter;

    if (this.userFilter.length > 0 && this.userFilter.length % 2 == 0) {
      this.usersComplete = this.users.filteredData;
    } else if (this.userFilter.length == 0) {
      this.usersComplete = [];
    }
  }

  openDialogVisualizarClient(id) {
    const dialogRef = this.dialog.open(
      MasterVisualizarUsuarioComponent,
      this.dialogConfig,
    );
    dialogRef.componentInstance.id = id;
    dialogRef
      .afterClosed()
      .toPromise()
      .then(_ => {
        this.getUsers();
      });
  }
  notExistClientWarn() {
    return;
  }

  openDialogCreateUser(): void {
    // if (!this.clientExist) {
    //   this.snackBarService.snackbarUtil.showWarn(
    //     `Todos os Clientes já possuem usuário Master relacionado`,
    //   );

    //   return;
    // }
    this.dialog
      .open(MasterCreateUserComponent, this.dialogConfig)
      .afterClosed()
      .toPromise()
      .then(_ => {
        this.getUsers();
      });
  }

  openDialogCreateUserMaster(): void {
    this.dialog
      .open(MasterClienteCreateUserComponent, this.dialogConfig)
      .afterClosed()
      .toPromise()
      .then(_ => {
        this.getUsers();
      });
  }
}
